// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["vendor/common","vendor/fancyapps"], () => (__webpack_require__("./sources/js/script.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendor/common","vendor/fancyapps"], () => (__webpack_require__("./sources/scss/style.scss")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
